function escapeCsvCell(value) {
  const text = String(value ?? '');
  const safeText = /^[=+\-@\t\r]/.test(text) ? `'${text}` : text;
  return `"${safeText.replaceAll('"', '""')}"`;
}

export function exportAvailability(records) {
  const rows = [...records]
    .filter((record) => record.id)
    .sort((a, b) => {
      const dateOrder = String(a.date || '').localeCompare(String(b.date || ''));
      return dateOrder || String(a.name || '').localeCompare(String(b.name || ''));
    })
    .map((record) => [
      record.date,
      record.shift,
      record.name,
      record.email,
      record.phone,
    ]);

  const content = [
    ['Date', 'Shift', 'Volunteer', 'Email', 'Phone'],
    ...rows,
  ]
    .map((row) => row.map(escapeCsvCell).join(','))
    .join('\r\n');

  const blob = new Blob(['\uFEFF', content], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `volunteer-roster-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}